import { Button, Textarea, useDeviceType } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './commentForm.css';
import { IUpdateNoteParams } from '../../actions/favoriteEntities/notes';
import { EDeviceType } from '../../types/device';

export interface ICommentFormProps {
  entityId: number;
  isFetching: boolean;
  comment?: string | null;
  onSubmitComment(params: IUpdateNoteParams): void;
  onCancelComment(entityId: number): void;
}

export interface ICommentFormState {
  comment: string;
}

export const CommentForm = ({ comment, isFetching, onCancelComment, onSubmitComment, entityId }: ICommentFormProps) => {
  const [nextComment, setNextComment] = React.useState(comment || '');

  const device = useDeviceType();
  const size = device === EDeviceType.Desktop ? 'XS' : 'M';

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleChange = React.useCallback((_event: any, value: string) => {
    setNextComment(value);
  }, []);

  const handleCancel = React.useCallback(() => {
    onCancelComment(entityId);
  }, [entityId, onCancelComment]);

  const handleSubmit = React.useCallback(() => {
    onSubmitComment({ comment: nextComment, entityId });
  }, [entityId, nextComment, onSubmitComment]);

  return (
    <div className={styles['container']}>
      <Textarea autoFocus size={size} value={nextComment} onChange={handleChange} minRows={2} disabled={isFetching} />
      <div className={styles['buttons']}>
        <Button size={size} disabled={isFetching} onClick={handleCancel} theme="fill_secondary">
          Отменить
        </Button>
        <Button
          size={size}
          loading={isFetching}
          disabled={isFetching || nextComment.trim().length === 0}
          onClick={handleSubmit}
        >
          Сохранить
        </Button>
      </div>
    </div>
  );
};
